import React from "react";
import { Box, Typography } from "@mui/material";
import ConstructionRoundedIcon from "@mui/icons-material/ConstructionRounded";
import { useTranslation } from "react-i18next";

/**
 * Estado vacio ("en construccion") mientras se define el contenido de un panel.
 * Es contenido plano (sin tarjeta): se coloca SIEMPRE dentro de un <Panel>, que
 * ya aporta la tarjeta de marca. Se sustituira por el grafico/KPI real.
 */
function Placeholder() {
    const { t } = useTranslation();
    return (
        <Box
            sx={{
                height: "100%",
                minHeight: 96,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                gap: 1,
                color: "text.secondary",
            }}
        >
            <ConstructionRoundedIcon color="disabled" />
            <Typography variant="body2">{t("common.comingSoon")}</Typography>
        </Box>
    );
}

export default Placeholder;
